import { render, staticRenderFns } from "./CitaCobertura.vue?vue&type=template&id=c178a27c"
import script from "./CitaCobertura.vue?vue&type=script&lang=js"
export * from "./CitaCobertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports